var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.66602,
    y: 11.9167,
    width: 3.66667,
    height: 5.5,
    rx: 1.83333,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.66602,
    y: 11.9167,
    width: 3.66667,
    height: 5.5,
    rx: 1.83333,
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.666,
    y: 11.9167,
    width: 3.66667,
    height: 5.5,
    rx: 1.83333,
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.666,
    y: 11.9167,
    width: 3.66667,
    height: 5.5,
    rx: 1.83333,
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 13.75V11C3.66602 6.9499 6.94926 3.66666 10.9993 3.66666C15.0494 3.66666 18.3327 6.9499 18.3327 11V13.75",
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.4167C16.5 18.9354 14.0376 20.1667 11 20.1667",
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.4167C16.5 18.9354 14.0376 20.1667 11 20.1667",
    stroke: "#6F6B7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIconBlack);
export default __webpack_public_path__ + "static/media/admin-icon-black.81613be7aa7d1d16db17bbde36953e3f.svg";
export { ForwardRef as ReactComponent };